import 'raf/polyfill'
import 'babel-polyfill'
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import {addFun} from '../../redux/user.redux'
import comFn from '../../component/common/common'
import axios from 'axios'
import { Link} from "react-router-dom"
import HeaderBar from '../../component/header/header.js'
import './index.css'
import Carousel from '../../component/swiper/index.js'
import MemberActive from '../../component/member-active/active.js'
import LoginBar from '../../component/login/login.js'
import NewGameRecommend from '../../component/new-games/newGames.js'
import ToastBar from '../../component/toast/toast.js'
import {getElementPosition} from '../../util.js'

import {getUnReadNum} from '../../redux/chatuser.redux.js'
import {getBigBGUrl} from '../../redux/chatuser.redux.js'

// 装饰器模式
@comFn
@withRouter
@connect(
  state=>state.chatuser,
  {getUnReadNum,getBigBGUrl}
)
class Index extends React.Component{
  constructor(props){
    super(props)
    this.state={
      getNewsData:'',
      visible:false,
      iTop:'',
      alertTitle:'',
      alertType:0,
      videoCon:'',
      VideoDrc:'',
      headerVisible:false

    }
    
    this.vipGrowth=''
   // this.myVideo2 = '<iframe style="margin-left:-35px" width="600px" height="400px" src="//player.bilibili.com/player.html?aid=46844464&cid=84404109&page=1" scrolling="no" border="0" frameborder="no" framespacing="0" allowfullscreen="true"> </iframe>'
    
   // <iframe src="//player.bilibili.com/player.html?aid=60374124&cid=105109991&page=1" scrolling="no" border="0" frameborder="no" framespacing="0" allowfullscreen="true"> </iframe>
    this.myVideo2 = '<iframe style="margin-left:-35px" width="600px" height="400px" src="//player.bilibili.com/player.html?aid=60374124&cid=105109991&page=1" scrolling="no" border="0" frameborder="no" framespacing="0" allowfullscreen="true"> </iframe>'
  }
 
  componentDidMount(){

    this.getNewsList()
    this.props.getUnReadNum()
  //  this.props.getBigBGUrl()
   
   
  }

  getNewsList(){
     const _this = this
     axios.get('fapi/getNews?count=5')
      .then(res=>{
        
        _this.setState({
            getNewsData:res.data.data
        })

         
     
    })  
   

  }
  
  showVideo(e,iSrc,iTitle){
    var onOff = 0
    if(iSrc===''){
      onOff=1
      this.setState({
        headerVisible:false
      })
    }
   
    if(iSrc!=''){
      onOff=0
       this.setState({
        headerVisible:false
      })
    }
    if(iSrc===3){
      onOff=1
      this.setState({
        headerVisible:true
      })
      console.log('23232')
    }
    if(iSrc==1){
      this.setState({
        'videoCon':this.myVideo2
      })
      console.log(2)
    }else{
     
      this.setState({
        'VideoDrc':iSrc
               
      },()=>{
          this.myVideo = '<div style="margin-left:-35px" className="my-video"><embed src="'+this.state.VideoDrc+'" allowFullScreen="true" quality="high" width="600" height="400" align="middle" allowScriptAccess="always" type="application/x-shockwave-flash"></embed></div>'
          this.setState({
            'videoCon':this.myVideo
          })
      })
     
    }
    console.log(onOff)
    this.setState({

      visible: true,
      iTop:getElementPosition(e.target).y+'px',
      alertTitle:iTitle,
      alertType:onOff

     
    })
  
  }
 
  handleNewsClass(data){
    var Myclass = []
    if(data==1){
      Myclass=['news-bg-1','公告']
      
    }else if(data==2){
      Myclass=['news-bg-2','活动']
    }else if(data==3){
      Myclass=['news-bg-3','新闻']
    }
    return Myclass

  }
  handleNewsOpt(itime){
      var num = itime.indexOf('-')+1
      var mTime = itime.substring(num,num+5)
      return mTime
  }
  toNews(){
    this.props.history.push('/news-list')
  }
  
  render(){
    const newsData = this.state.getNewsData
   


    return (
      <div className="page-index my-wrap" style={{backgroundImage :'url('+this.props.bigBg+')'}}>

      	<HeaderBar></HeaderBar>
      	<section className="sec2">
          <div className="banner-box">
      			<LoginBar showLogin={this.props.showLogin}>
                
            </LoginBar>
            <div className="banner-con">
              <Carousel></Carousel>
            </div>
            
          </div>
      	</section>
        <section>
            <div className="news">
                <div className="news-title"><h6>新闻公告</h6><Link to="/news-list"></Link></div>

                <ul>
                  {
                    newsData?newsData.map((item,i) =>{

                       const iClass =this.handleNewsClass(item.category)
                      
                       return item.linkurl?<li key={i}><span className={iClass[0]}>{iClass[1]}</span><a href={item.linkurl} target="_blank">{item.title}</a><em>{this.handleNewsOpt(item.start_time)}</em></li>:
		                     <li key={i}><span className={iClass[0]}>{iClass[1]}</span><Link dangerouslySetInnerHTML={{ __html: item.title}} to={"news-detail/"+item.id}></Link><em>{this.handleNewsOpt(item.start_time)}</em></li>
                     }):null
                  }
                    
                   
                </ul>
            </div>

            <div className="member-active">
                <div className="member-title"><h6>会员活动</h6><a style={{display:"none"}}></a></div>
                <MemberActive></MemberActive>

               
            </div>
           <ul className="aside-list">
              <li><a href="javascript:;" onClick={(e)=>this.showVideo(e,3,'温馨提示')}>客户经理</a></li>
              <li><a href="/yx/club/index.html" >G福利</a></li>
              <li><a href="javascript:;" onClick={(e)=>this.showVideo(e,'','温馨提示')}>账号鉴定</a></li>
              <li><a href="http://xinyue.qq.com/act/pc/a20170812rxgc/home.shtml" target="_blank">传奇悦享会</a></li>

           </ul>         

        </section>

        <section className="new-games-box">
          
            <NewGameRecommend></NewGameRecommend>
        </section>

        <section className="below-line-box">
          <ul>
            <li>
              <h6>心享明星</h6>

              <div className="detail">
                <div className="left"></div>
                <div className="right">
                    <div className="star-name">高级客户经理<span>桃子</span></div>
                    
                    <p>热爱生活的可爱美少女，同时拥有二次元隐藏属性的电竞宅女， 希望能和每一个玩家无话不谈，成为您游戏上最好的小伙伴。</p>

                </div>
               
              </div>
            </li>
             <li>

              <h6>线下活动视频</h6>
              <div className="detail">
                <div className="play-btn-bg"></div>
                                                        
                <button onClick={(e)=>this.showVideo(e,'1','线下活动视频')}></button>
                <em>龙之谷九周年线下泳池趴激情回顾</em>



              </div>
              
            </li>
            <li>
              <h6></h6>
              <div className="detail">
                
                <div className="play-btn-bg"></div>
                <button  onClick={(e)=>this.showVideo(e,'https://vswf.douyucdn.cn/share/vshare.swf?vid=aRbBv30G1yY76PYV','线下活动视频')}></button>
                <em>传奇世界3D品鉴会</em>

              </div>
            </li>

          </ul>

        </section>
        {
          this.state.visible&&<ToastBar 
          visible={this.state.visible} 
            title={this.state.alertTitle}  
            isOkShow ={false} iTop={this.state.iTop}
          >{this.state.alertType?this.state.headerVisible?<div className="plus-code">
              <span className="code-img"></span>
              <span className="code-text">添加心享plus小程序  享1对1专属服务</span>
            </div>:<div className="alert-notice">正在建设中...</div>:this.state.videoCon}
          </ToastBar>
        }
        
        
      </div>
    ) 
  }
}
export default Index;



// WEBPACK FOOTER //
// ./src/container/index/index.js